<!-- message.component.html -->

<div *ngIf="message" [ngClass]="message.type" class="message">
    <span [innerHTML]="message.text"></span>
  </div>
  